import { render, staticRenderFns } from "./FeeFailedFooter.vue?vue&type=template&id=6f1f090c&"
import script from "./FeeFailedFooter.vue?vue&type=script&lang=js&"
export * from "./FeeFailedFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports